import { IAppState } from 'shared/common/state';

// TODO: Удалить в CD-226143/CD-225150. Онбординги на месяц.
export function selectChatOnboarding(state: IAppState) {
  return state.chatOnboarding;
}
